import { Button, Form, Input } from 'reactstrap'
import PubSub from 'pubsub-js'
import { publishEvent } from '../../utils'
import useForm from '../CustomHooks/FormHook'
import './PDFControls.css'

export default function PDFControls() {
  function refreshClicked() {
    const eventName = 'PDF Refresh Button'
    console.log(PubSub.getSubscriptions('PDF Refresh Button'))
    publishEvent(eventName, inputs, 'PDFControls')
  }

  const initialValues = {
    pageSize: 'letter',
    orientation: 'landscape',
    fontSize: 13,
    repeatHeadings: '1'
  }
  const { inputs, handleInputChange } = useForm(initialValues)

  const pageSizeOptions = [<option key="Letter" value="LETTER" >Letter</option>, <option key="Legal" value="LEGAL" >Legal</option>]
  const pageOrientationOptions = [<option key="landscape" value="landscape">Landscape</option>, <option key="portrait" value="portrait">Portrait</option>]
  const fontSizeOptions = [
    <option key="8" value="8">8</option>,
    <option key="9" value="9">9</option>,
    <option key="10" value="10">10</option>,
    <option key="11" value="11">11</option>,
    <option key="12" value="12">12</option>,
    <option key="13" value="13">13</option>,
    <option key="14" value="14">14</option>,
    <option key="15" value="15">15</option>,
    <option key="16" value="16">16</option>,
    <option key="17" value="17">17</option>,
    <option key="18" value="18">18</option>,
    <option key="19" value="19">19</option>,
    <option key="20" value="20">20</option>,
  ]
  const repeatHeadingsOptions = [<option key="1" value="1">Yes</option>, <option key="0" value="0">No</option>]


  return (
    <Form>
      <div className='pdfOptions'> Page Size
        <Input type="select" name="pageSize" defaultValue={inputs.pageSize} onChange={handleInputChange}>
          {pageSizeOptions}
        </Input>
      </div>
      <div className='pdfOptions'> Page Orientation
        <Input type="select" name="orientation" defaultValue={inputs.orientation} onChange={handleInputChange}>
          {pageOrientationOptions}
        </Input>
      </div>
      <div className='pdfOptions'> Font Size
        <Input type="select" name="fontSize" defaultValue={inputs.fontSize} onChange={handleInputChange}>
          {fontSizeOptions}
        </Input>
      </div>
      <div className='pdfOptions'> Repeat Column Headings
        <Input type="select" name="repeatHeadings" defaultValue={inputs.repeatHeadings} onChange={handleInputChange}>
          {repeatHeadingsOptions}
        </Input>
      </div>
      <Button onClick={refreshClicked} style={{marginTop: '9px'}}>Refresh</Button>
    </Form>
  )
}